import { useState } from 'react';
import { api } from '../lib/api';
import PanelBrandLockup from '../components/ui/PanelBrandLockup';
import { PublicPanelCard, PublicPanelShell } from '../components/ui/PublicPanelShell';

interface Props {
  onLogin: () => void;
  onSwitchToSignup: () => void;
}

export default function LoginPage({ onLogin, onSwitchToSignup }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.auth.login(email, password);
      onLogin();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PublicPanelShell>
      <div className="mb-8 w-full">
        <PanelBrandLockup
          title="Inicia sesión"
          subtitle="Entra a tu panel y sigue administrando tu sitio desde un solo lugar."
          compact
          minimal
        />
      </div>
      <PublicPanelCard>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-1">
            <h2 className="text-xl font-semibold text-ui-text">Bienvenido de vuelta</h2>
            <p className="text-sm text-ui-text-muted">Usa tu correo y tu contraseña para entrar.</p>
          </div>

          <div className="space-y-3">
            <div>
              <label className="block text-sm text-ui-text-muted mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                className="w-full bg-ui-bg border border-ui-border rounded-lg px-3 py-2 text-sm text-ui-text placeholder-ui-text-subtle focus:outline-none focus:border-ui-accent"
              />
            </div>
            <div>
              <label className="block text-sm text-ui-text-muted mb-1">Contraseña</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-ui-bg border border-ui-border rounded-lg px-3 py-2 text-sm text-ui-text placeholder-ui-text-subtle focus:outline-none focus:border-ui-accent"
              />
            </div>
          </div>

          {error && <p className="text-sm text-ui-danger">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2.5 bg-ui-accent text-ui-text-inverse text-sm font-medium rounded-lg disabled:opacity-50 hover:opacity-90 transition-opacity"
          >
            {loading ? 'Entrando…' : 'Entrar'}
          </button>

          <p className="text-sm text-ui-text-subtle text-center">
            ¿No tienes cuenta?{' '}
            <button type="button" onClick={onSwitchToSignup} className="text-ui-accent hover:underline">
              Crea tu sitio
            </button>
          </p>
        </form>
      </PublicPanelCard>
    </PublicPanelShell>
  );
}
